import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function BrandHeader({ back = false, title, subtitle, tone = "light" }) {
  const navigate = useNavigate();
  const isDark = tone === "dark";
  return (
    <header
      data-testid="brand-header"
      className={`sticky top-0 z-40 ${
        isDark
          ? "bg-[#092C15]/90 text-white"
          : "bg-white/85 text-[#092C15]"
      } backdrop-blur-md border-b ${
        isDark ? "border-white/10" : "border-emerald-900/10"
      }`}
    >
      <div className="mx-auto max-w-3xl px-4 py-3 flex items-center gap-3">
        {back ? (
          <div className="flex items-center gap-1">
          <button
            data-testid="header-back-button"
            onClick={() => navigate(-1)}
            className={`p-2 -ml-2 rounded-full ${
              isDark ? "hover:bg-white/10" : "hover:bg-emerald-900/5"
            }`}
            aria-label="Go back"
          >
            <ChevronLeft size={22} />
          </button>
          <Link to="/" data-testid="header-logo-link">
            <img
              data-testid="header-logo-image"
              src="/greenflow-logo-clean.webp"
              alt="GreenFlow Landscape Vision"
              className="h-10 w-auto rounded-md bg-white p-0.5"
            />
          </Link>
          </div>
        ) : (
          <Link
            data-testid="header-logo-link"
            to="/"
            className="flex items-center gap-2"
          >
            <img
              data-testid="header-logo-image"
              src="/greenflow-logo-clean.webp"
              alt="GreenFlow Landscape Vision"
              className="h-11 w-auto rounded-md bg-white p-0.5"
            />
          </Link>
        )}
        <div className="flex-1 min-w-0">
          <div
            className={`text-[11px] uppercase tracking-[0.18em] font-bold ${
              isDark ? "text-emerald-300" : "text-emerald-700"
            }`}
          >
            GreenFlow Vision
          </div>
          {title && (
            <div className="font-display font-semibold text-base truncate">
              {title}
            </div>
          )}
          {subtitle && (
            <div
              className={`text-xs truncate ${
                isDark ? "text-emerald-100/70" : "text-slate-500"
              }`}
            >
              {subtitle}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
